// extracted by mini-css-extract-plugin
export default {"WebhooksIntegrations":"WebhooksIntegrations_WebhooksIntegrations__oC6aY","group":"WebhooksIntegrations_group__0c707","name":"WebhooksIntegrations_name__lQeG0"};